// react
import ReCAPTCHA from "react-google-recaptcha";
import React, {useState} from "react";
import { FormattedMessage } from "react-intl";

// third-party
import { Helmet } from "react-helmet-async";

// application
import PageHeader from "../shared/PageHeader";

// blocks
import BlockMap from "../blocks/BlockMap";

// data stubs
import theme from "../../data/theme";
import shopApi from "../../api/shop";

function SitePageContactUs() {
    const breadcrumb = [
        { title: <FormattedMessage id="header.home" defaultMessage="Home" />, url: "" },
        { title: <FormattedMessage id="header.contactUs" defaultMessage="Contact Us" />, url: "" },
    ];

    const [recaptchaToken, setRecaptchaToken] = useState("");
    

    const handleRecaptcha = (token) => {
        setRecaptchaToken(token);
    };


    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });

    

    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            shopApi.sendEmail({...formData, recaptchaToken});
            setFormData({
                name: "",
                email: "",
                subject: "",
                message: "",
            });
            setStatus({ type: "success", message: "Message sent successfully!" });
        } catch (error) {
            setStatus({ type: "error", message: "Failed to send message. Try again later." });
        }
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Contact Us — ${theme.name}`}</title>
            </Helmet>

            {/* <BlockMap /> */}

            <PageHeader header={<FormattedMessage id="header.contactUs" defaultMessage="Contact Us" />} breadcrumb={breadcrumb} />

            <div className="block">
                <div className="container">
                    <div className="card mb-0">
                        <div className="card-body contact-us">
                            <div className="contact-us__container">
                                <div className="row">
                                    <div className="col-12 col-lg-6 pb-4 pb-lg-0">
                                        <h4 className="contact-us__header card-title"><FormattedMessage id="Site.OurAddress" defaultMessage="Our Address" /></h4>

                                        <div className="contact-us__address">
                                            <p>
                                                {theme.contacts.address}
                                                <br />
                                                <FormattedMessage id="Site.OurAddress.Email" defaultMessage="Email:" />
                                                <br />
                                                {/* <FormattedMessage id="Site.OurAddress.PhoneNumber" defaultMessage="Phone Number:" /> */}
                                            </p>
{/* 
                                            <p>
                                                <strong><FormattedMessage id="Site.OpeningHours" defaultMessage="Opening Hours" /></strong>
                                                <br />
                                                <FormattedMessage id="Site.OpeningHours.MondayToFriday" defaultMessage="Monday to Friday: 8am-8pm" />
                                                <br />
                                                <FormattedMessage id="Site.OpeningHours.Saturday" defaultMessage="Saturday: 8am-6pm" />
                                                <br />
                                                <FormattedMessage id="Site.OpeningHours.Sunday" defaultMessage="Sunday: 10am-4pm" />
                                            </p> */}
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-6">
                                        <h4 className="contact-us__header card-title"><FormattedMessage id="Site.LeaveUsAMessage" defaultMessage="Leave us a Message" /></h4>

                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <label><FormattedMessage id="Site.YourName" defaultMessage="Your Name" /></label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label><FormattedMessage id="Site.Email" defaultMessage="Email" /></label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label><FormattedMessage id="Site.Subject" defaultMessage="Subject" /></label>
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label><FormattedMessage id="Site.Message" defaultMessage="Message" /></label>
                                                <textarea
                                                    name="message"
                                                    className="form-control"
                                                    rows="4"
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                            </div>
                                            <ReCAPTCHA name="recaptchaToken" sitekey="6LfICLwqAAAAAHCW3kfNzQhxbtYabKLISXtBrg2K" onChange={handleRecaptcha} />
                                            <button type="submit" className="btn btn-primary mt-3">
                                                <FormattedMessage id="Site.Send" defaultMessage="Send" />
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SitePageContactUs;
